// REL_1.1.15 F-262 §2 — Multi-currency display constants.
// Per Corrigendum 2: country hardcoded to US; manual override available via currency selector.
// Per spec §2.3: deploy-time-fixed conversion (NOT real-time forex); refresh at next deploy.

// REL_1.1.15D E-120 (Q1 ruling 2026-06-16): North-America-only → AUD removed (Australia is not NA;
// signup is +1-only US/CA). Reversible — re-add the "AUD" union member + the CURRENCIES/FX_RATES rows.
// REL_1.1.15E F-313 (S-1228, 2026-07-09): US-primary marketing → CAD HIDDEN (marketing display only;
// backend unchanged). With a single currency the CurrencySelector self-hides. Reversible — re-add "CAD".
export type CurrencyCode = "USD"; // was "USD" | "CAD" — CAD hidden per F-313 (reversible)

export const CURRENCIES: ReadonlyArray<{
  code: CurrencyCode;
  label: string;
  symbol: string;
  locale: string;
}> = [
  { code: "USD", label: "US Dollar", symbol: "$", locale: "en-US" },
  // REL_1.1.15E F-313 hide-Canada (reversible): { code: "CAD", label: "Canadian Dollar", symbol: "$", locale: "en-CA" },
] as const;

// Deploy-time-fixed conversion rates per spec §2.3. Refresh at next deploy.
// Baseline: USD. Refreshed: 2026-05-28 at REL_1.1.15 ship.
const FX_RATES: Record<CurrencyCode, number> = {
  USD: 1.0,
  // REL_1.1.15E F-313 hide-Canada (reversible): CAD: 1.34,
};

export function convertFromUSD(usdAmount: number, target: CurrencyCode): number {
  return Math.round(usdAmount * FX_RATES[target]);
}

export function formatCurrency(amount: number, code: CurrencyCode): string {
  const meta = CURRENCIES.find((c) => c.code === code);
  const locale = meta?.locale ?? "en-US";
  return new Intl.NumberFormat(locale, {
    style: "currency",
    currency: code,
    maximumFractionDigits: 0,
  }).format(amount);
}
